export const UPD_ER_MEDICATIONS_SUSP = 'UPD_ER_MEDICATIONS_SUSP';
export const UPD_ER_IMPUTABILITY_EVALUATION = 'UPD_ER_IMPUTABILITY_EVALUATION';
export const UPD_ER_RAM = 'UPD_ER_RAM';
export const UPD_ER_RAM_CATEGORY = 'UPD_ER_RAM_CATEGORY';
export const UPD_ER_MEDICATION_HISTORY = 'UPD_ER_MEDICATION_HISTORY';
export const UPD_ER_FABRIC_APPROVED='UPD_ER_FABRIC_APPROVED';